// Step2Description.tsx
import React from "react";
import TextEditor from "../../components/texteditor/TextEditor";


interface Step2DescriptionProps {
  description: string;
  setDescription: React.Dispatch<React.SetStateAction<string>>;
  errors: { [key: string]: string };
}

const Step2Description: React.FC<Step2DescriptionProps> = ({
                                                             description,
                                                             setDescription,
                                                             errors,
                                                           }) => {
  return (
    <div className="w-full">
      <label htmlFor="description" className="block text-sm font-medium text-gray-700">
        상품 설명 <span className="text-red-500">*</span>
      </label>
      <p className="text-gray-500 text-sm mb-2 flex justify-between">
        <span>상품의 설명을 입력해주세요.</span>
        </p>
        <TextEditor
          value={description}
          onChange={setDescription}
          height="200px" // 원하는 높이로 설정 가능
        />
        {errors.description && (
          <p className="mt-2 text-sm text-red-600" id="description-error">
            {errors.description}
          </p>
        )}
    </div>
);
};

export default Step2Description;
